import styled from '@emotion/styled';

const ToggleLabel = styled('label')`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: 2px;
    margin-bottom: 15px;

    .label-text {
        margin-left: 5px;

        &.label-placement-left {
            margin-left: 0;
            margin-right: 5px;
        }
    }

    .form-button-group & {
        margin-bottom: 0;
        margin-right: 1em;

        &:last-child {
            margin-right: 0;
        }
    }

    thead & {
        margin-bottom: 0;
    }
`;

export default ToggleLabel;
